export const ADD_ERRORS = 'add-account-errors';
const addErrors = errors => ({ type: ADD_ERRORS, payload: { errors } });
export default addErrors;
